export default class Globais {
  static conta = '514066249'
  static cnpj = '18188611000170'
  static coduser = '1'
}
